import { WebLeft, WebWidth } from "./config/config";
import { BrowserRouter } from "react-router-dom";
import { F_Fammily } from "./util/config-fonts";
import { isMobile } from "react-device-detect";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import Rootes from "./routes/routes";
import "./styles/fonts/UberMoveMedium.ttf";
import "./styles/fonts/UberMoveRegular.ttf";
import "./styles/css/font.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (isMobile) {
  root.render(
    <div
      id="MobileView"
      style={{ fontFamily: F_Fammily.Regular, backgroundColor: "white" }}
    >
      <BrowserRouter>
        <Suspense>
          <Rootes />
        </Suspense>
      </BrowserRouter>
    </div>
  );
} else {
  root.render(
    <div
      className="WindowDevice"
      style={{
        margin: "auto",
        position: "fixed",
        left: WebLeft,
        width: WebWidth,
        height: "100%",
        overflow: "auto",
        boxShadow: "0px 4px 8px 0px",
        fontFamily: F_Fammily.Regular,
        backgroundColor: "white",
      }}
    >
      <BrowserRouter>
        <Suspense>
          <Rootes />
        </Suspense>
      </BrowserRouter>
      <div id="MobileView" style={{}}></div>
    </div>
  );
}
